import styles from './Section05.module.css';
import FlowingMenu from '../Ui/FlowingMenu';

const demoItems = [
    { link: '/about', text: 'association', image: '/image/logoicon-01.png' },
    { link: '/program', text: 'program', image: '/image/logoicon-02.png' },
    { link: '/consulting', text: 'Consulting', image: '/image/logoicon-03.png' },
    { link: '/membership', text: 'membership', image: '/image/logoicon-04.png' },
    { link: '/news', text: 'news', image: '/image/logoicon-05.png' },
  ];


function Section05() {
    return (
        <div className={styles.section05}>
            <div className={styles.section05Container}>
                <FlowingMenu items={demoItems} />
            </div>
        </div>
    );
}
  
export default Section05;

